import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Statistics',
  weeks: [11, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'DrawLineGraphs',
      questionTypes: ['aSi', 'aSj', 'aSk', 'aSl', 'aSm', 'aSn'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/1DrawLineGraphs" */ './1DrawLineGraphsModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'ReadAndInterpretLineGraphs',
      questionTypes: ['aSo', 'aSp', 'aSq', 'aSr', 'aSs', 'aSt'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/2ReadAndInterpretLineGraphs" */ './2ReadAndInterpretLineGraphsModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'ReadAndInterpretTables',
      questionTypes: ['aSu', 'aSv', 'aSw', 'aSx', 'aSy', 'aSz'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/3ReadAndInterpretTables" */ './3ReadAndInterpretTablesModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'TwoWayTables',
      questionTypes: ['aSA', 'aSB', 'aSC', 'aSD2', 'aSE', 'aSF'],
      archivedQuestionTypes: ['aSD'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/4TwoWayTables" */ './4TwoWayTablesModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'ReadAndInterpretTimetables',
      questionTypes: ['aSG', 'aSH', 'aSI', 'aSJ', 'aSK2', 'aSL2'],
      archivedQuestionTypes: ['aSK', 'aSL'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/Statistics/5ReadAndInterpretTimetables" */ './5ReadAndInterpretTimetablesModels'
        )
    })
  ]
});
export default Block;
